module.exports = __webpack_public_path__ + "media/site/images/case_studies/sensor_cloud/architecture-f558a8e1d7e0cbcd56618ca6c0a64abf.svg";